import React from 'react';

import { AutoSuggestControl } from 'app/components/Controls';
import { getCapitalized } from 'app/shared/helpers/getCapitalized';
import { useNameControl } from 'app/shared/hooks/controls/useNameControl';
import { NameControlProps } from './NameControl.interfaces';

export default function NameControl(props: NameControlProps) {
  const { handleChange, handleFocus, handleBlur } = useNameControl(props);

  return (
    <AutoSuggestControl
      {...props}
      handleChange={handleChange}
      handleFocus={handleFocus}
      handleBlur={handleBlur}
      formatValue={getCapitalized}
    />
  );
}
